module.exports = __webpack_public_path__ + "static/media/advice.6aa383f1.svg";